export default {
  demandDataGrid: {},
  demandDataList: {}
}
